/**
 * Breed LP — Tab Container controller.
 * Pure attribute toggling. No fetch, no Section Rendering API.
 */
(function () {
  const ROOT_SELECTOR = '.breedlp-tab-container';
  const TAB_SELECTOR = '.breedlp-tab-container__tab';
  const ACTIVE_CLASS = 'is-active';

  const init = (root) => {
    const tabs = Array.from(root.querySelectorAll(TAB_SELECTOR));
    if (tabs.length === 0) return;

    const activate = (tab) => {
      const panelId = tab.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      for (const otherTab of tabs) {
        const isActive = otherTab === tab;
        otherTab.classList.toggle(ACTIVE_CLASS, isActive);
        otherTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        otherTab.setAttribute('tabindex', isActive ? '0' : '-1');

        const otherPanelId = otherTab.getAttribute('aria-controls');
        const otherPanel = otherPanelId ? document.getElementById(otherPanelId) : null;
        if (otherPanel) {
          otherPanel.toggleAttribute('hidden', !isActive);
        }
      }

      // Carousel controls inside the now-visible panel computed their
      // progress bar against a zero-width hidden container at init time.
      // A resize event makes them recalculate against the real dimensions.
      window.dispatchEvent(new Event('resize'));
    };

    for (const tab of tabs) {
      tab.addEventListener('click', () => activate(tab));
    }

    root.addEventListener('keydown', (event) => {
      if (!event.target.matches(TAB_SELECTOR)) return;

      const currentIndex = tabs.indexOf(event.target);
      let nextIndex = -1;

      if (event.key === 'ArrowRight') {
        nextIndex = (currentIndex + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      }

      if (nextIndex >= 0) {
        event.preventDefault();
        activate(tabs[nextIndex]);
        tabs[nextIndex].focus();
      }
    });
  };

  const initAll = () => {
    for (const root of document.querySelectorAll(ROOT_SELECTOR)) {
      init(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (root) init(root);
  });
})();
